import { gql } from '@apollo/client';

export const createOnboardingRequest = gql`
  mutation createOnboardingRequest(
    $name: String!
    $shopName: String!
    $phone: String!
    $email: String
    $categoriesIds: [ID!]!
  ) {
    createOnboardingRequest(
      name: $name
      shopName: $shopName
      phone: $phone
      email: $email
      categoriesIds: $categoriesIds
    ) {
      entity
    }
  }
`;
